<!-- -------------------------Call Back Section Start----------------- -->

<section class="sscp40 rs-section cb" rsParallax>
    <div class="rs-deco" aria-hidden="true">
        <span class="rs-blob rs-blob--pink rs-blob--tl"></span>
        <span class="rs-blob rs-blob--purple rs-blob--tr"></span>
        <span class="rs-blob rs-blob--indigo rs-blob--br"></span>
        <span class="rs-dots rs-dots--a"></span>
        <span class="rs-dots rs-dots--pink rs-dots--b"></span>
        <span class="rs-ring rs-ring--a"></span>
        <span class="rs-ring rs-ring--b"></span>
        <span class="rs-spark" style="--sx: 20%; --sy: 24%; --sd: 0s"></span>
        <span class="rs-spark" style="--sx: 76%; --sy: 32%; --sd: 1.3s"></span>
        <span class="rs-spark" style="--sx: 46%; --sy: 80%; --sd: 2.6s"></span>
    </div>

    <div class="container rs-shell">
        <div class="section_heading cb__panel" rsReveal="up" rsRevealImmediate>
            <span class="rs-badge rs-badge--spark">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M12 2l1.9 5.6L19.5 9.5 13.9 11.4 12 17l-1.9-5.6L4.5 9.5l5.6-1.9L12 2z"
                        fill="currentColor" />
                </svg>
                Free 30-minute call
            </span>

            <h2>Connect our <span class="rs-title-grad">Business Expert</span></h2>
            <span class="rs-rule rs-rule--center" aria-hidden="true"></span>
            <p>Heavenly bodies sent you to this page. Now, you need to take an initiative.</p>

            <ul class="cb__perks" aria-label="What to expect">
                <li>
                    <span class="cb__perk-ico" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    A senior engineer, not a call centre
                </li>
                <li>
                    <span class="cb__perk-ico" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    Scope, timeline and a clear estimate
                </li>
                <li>
                    <span class="cb__perk-ico" aria-hidden="true">
                        <svg viewBox="0 0 24 24" fill="none">
                            <path d="M4 12.5l5 5L20 6.5" stroke="currentColor" stroke-width="2.4"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                    No obligation to continue
                </li>
            </ul>

            <div class="Consult_btn">
                <app-consult-now-modal id="requestcallbackdialog" class="auto_center">
                </app-consult-now-modal>
            </div>
        </div>
    </div>
</section>

<!-- -------------------------Call Back Section End----------------- -->
